import script from "./sendListPop.vue?vue&type=script&setup=true&lang=js"
export * from "./sendListPop.vue?vue&type=script&setup=true&lang=js"

import "./sendListPop.vue?vue&type=style&index=0&id=8fbc62f4&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fbc62f4"]])

export default __exports__